import { lifestyleImages } from "@/mocks/techData";

const moments = [
  { icon: "ri-phone-line", text: "Your phone on the desk, charged and ready." },
  { icon: "ri-computer-line", text: "A laptop that keeps up with your day." },
  { icon: "ri-headphone-line", text: "Headphones for focus, calls and downtime." },
  { icon: "ri-speaker-2-line", text: "A speaker that fills the room." },
];

export default function EverydayTech() {
  return (
    <section id="everyday" className="bg-background-50 py-20 md:py-28">
      <div className="container-x grid items-center gap-8 lg:grid-cols-2">
        {/* Editorial collage */}
        <div className="relative">
          <div className="overflow-hidden rounded-xl">
            <div className="aspect-[4/3]">
              <img
                src={lifestyleImages.everyday}
                alt="Everyday technology setup with smartphone, laptop and headphones from Fist Limited in Liverpool"
                className="h-full w-full object-cover"
              />
            </div>
          </div>
          <div className="absolute -bottom-6 -right-3 hidden w-48 overflow-hidden rounded-lg border-4 border-background-50 shadow-none sm:block md:-right-6 md:w-56">
            <div className="aspect-square">
              <img
                src={lifestyleImages.handsPhone}
                alt="Hands using a premium smartphone from Fist Limited"
                className="h-full w-full object-cover"
              />
            </div>
          </div>
          <span className="absolute -top-4 left-4 rounded-full bg-primary-500 px-4 py-2 font-label text-[10px] text-foreground-950">
            Everyday Tech
          </span>
        </div>

        {/* Text */}
        <div>
          <p className="eyebrow mb-4 flex items-center gap-3">
            <span className="inline-block h-px w-8 bg-foreground-950"></span>
            In Real Life
          </p>
          <h2 className="section-title">Tech that fits into your everyday.</h2>
          <p className="mt-4 max-w-lg text-sm leading-relaxed text-foreground-600">
            Fist Limited isn't just about specs — it's about technology that works for real life in
            Liverpool. Phones, laptops and the accessories that keep your day moving.
          </p>

          <ul className="mt-8 space-y-4">
            {moments.map((m) => (
              <li key={m.text} className="flex items-center gap-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-foreground-950 text-primary-400">
                  <i className={`${m.icon} text-lg`}></i>
                </span>
                <span className="text-sm text-foreground-700">{m.text}</span>
              </li>
            ))}
          </ul>

          <a href="#visit" className="btn-dark mt-9 h-12 px-6 text-sm">
            Talk to Us <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}